import React from 'react';
import BirdCourier from './BirdCourier';
import { useRevealOnce } from '../animations/MotionPrimitives';
import './SectionCourier.css';

/*
 * SectionCourier
 * The recurring courier as it appears in each chapter: it flies in ONCE when
 * the section first scrolls into view, then settles into a static pose — it
 * does not loop or fly continuously. Positioning is the parent's job (via
 * `className`); this component only owns the entrance + the pose.
 *
 * It shares the page-wide reveal machinery (useRevealOnce), so under
 * prefers-reduced-motion — or in a background tab, or without
 * IntersectionObserver — the bird is simply rendered in its resting pose.
 */
function SectionCourier({
  className = '',
  width = 74,
  carry = 'none',
  from = { x: -12, y: 14, rotate: -10 },
  restRotate = -3,
  delay = 0,
}) {
  const { ref, phase, handleAnimationEnd } = useRevealOnce(delay);
  const animating = phase === 'hidden' || phase === 'in';

  const classNames = [
    'section-courier',
    className,
    phase === 'hidden' && 'courier-pending',
    phase === 'in' && 'courier-run',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      ref={ref}
      className={classNames}
      aria-hidden="true"
      style={{
        '--courier-rest': `${restRotate}deg`,
        '--courier-from-x': `${from.x}px`,
        '--courier-from-y': `${from.y}px`,
        '--courier-from-rotate': `${from.rotate}deg`,
      }}
      onAnimationEnd={animating ? handleAnimationEnd : undefined}
    >
      <BirdCourier width={width} carry={carry} />
    </span>
  );
}

export default SectionCourier;
